var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalkthroughOverlayPdfBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 662,
    height: 299,
    viewBox: "0 0 662 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 47.9716V299H662V46.4655C585.42 18.1718 466.518 0 333.006 0C197.139 0 76.4025 18.8182 0 47.9716Z",
    fill: "#2E3641",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkthroughOverlayPdfBg);
export default __webpack_public_path__ + "static/media/walkthroughOverlayPdfBg.c428b86e5c878ee759275b63a6d6ba47.svg";
export { ForwardRef as ReactComponent };